import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.cuentasBancarias.lista', {
    url: '',
    template,
    data: {
      title: 'Cuentas Bancarias',
    },
    resolve: {
      clientes: (CuentasBancarias) => CuentasBancarias.obtenerClientes(),
    },
    controllerAs: '$ctrl',
    controller (clientes, CuentasBancarias) {
      var $ctrl = this
      $ctrl.exportando = false

      $ctrl.clientes = clientes
      $ctrl.filtro = {
        cliente: '',
      }

      $ctrl.exportar = function () {
        return CuentasBancarias.exportartodascuentasbancarias()
          .then((data) => ($ctrl.data = data))
      }
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/bancosCuentas/routes/cuentasBancarias/lista/lista.js